import React, {Component} from "react";
import {map} from "lodash";
import Dropzone from 'react-dropzone';

const TYPE_JOIN_APPLICATION_SCAN = 1;
const TYPE_JOIN_APPLICATION_ECP = 2;
const TYPE_PASSPORT = 3;
const TYPE_IPN = 4;
const TYPE_OWNERSHIP = 5;
const TYPE_JOIN_OPERATOR_GRM = 6;

const STATUS_DONE = '5';
const STATUS_TRANSFER = '8';

export default class Documents extends Component {
    constructor() {
        super(...arguments);

        const application = JSON.parse(this.props.application);
        this.initStatus = application.status.toString();

        this.state = {
            application: application,
            documentRelations: application.document_relations,
            disable: application.status === STATUS_DONE || application.status === STATUS_TRANSFER,
            errors: {},
            success: false,
        }

        this.handleChangeFile = this.handleChangeFile.bind(this);
        this.handleDeleteFile = this.handleDeleteFile.bind(this);
        this.onChange = this.onChange.bind(this);
        this.updateDocumentRelations = this.updateDocumentRelations.bind(this);
        this.save = this.save.bind(this);
    }

    appendDocument(formData, key) {
        const {application} = this.state;

        let document = application[key];
        if (document) {
            for (let i = 0; i < document.length; i++) {
                let file = document[i];
                formData.append(`${key}[old][${i}]`, file.id)
            }
        }

        let newDocument = application[`new_${key}`];
        if (newDocument) {
            for (let i = 0; i < newDocument.length; i++) {
                let file = newDocument[i];
                if (file) {
                    formData.append(`${key}[new][${i}]`, file);
                }
            }
        }

        let newVersionDocument = application[`new_v_${key}`];
        if (newVersionDocument) {
            for (let i = 0; i < newVersionDocument.length; i++) {
                let file = newVersionDocument[i];
                if (file) {
                    formData.append(`${key}[new_v][${i}][comment]`, file.comment);
                    formData.append(`${key}[new_v][${i}][file]`, file.file);
                    formData.append(`${key}[new_v][${i}][old_file_id]`, file.old_file_id);
                }
            }
        }

        return formData;
    }

    getFormData () {
        const {application, documentRelations} = this.state;
        let formData = new FormData();
        const excessiveKeys = ['id', 'partner_id', 'source', 'personal_account_number', 'created_at', 'updated_at'];
        _.map(application, (value, key) => {
            if (!excessiveKeys.includes(key) && typeof value !== 'object') {
                formData.append(key, value ? value : '')
            }
        });

        formData.append('document_relations', JSON.stringify(documentRelations));

        formData = this.appendDocument(formData, 'join_scan_document');
        formData = this.appendDocument(formData, 'join_ecp_document');
        formData = this.appendDocument(formData, 'passport_document');
        formData = this.appendDocument(formData, 'ipn_document');
        formData = this.appendDocument(formData, 'ownership_document');
        formData = this.appendDocument(formData, 'join_operator_grm_document');

        return formData;
    }

    save() {
        const formData = this.getFormData();
        formData.append('_method', 'PUT');
        let url = '/upload-documents/';

        axios.post(url + this.state.application.id, formData)
            .then((res) => {
                this.setState({success: true})
            })
            .catch((error) => {
                this.setState({errors: error.response.data.errors || {}})
            })
    }

    onChange(attr, value) {
        this.setState(prevState => ({
            application: {
                ...prevState.application,
                [attr]: value
            }
        }))
    }

    updateDocumentRelations(value) {
        this.setState(prevState => ({
            documentRelations: {
                ...prevState.documentRelations,
                ...value
            },
        }));
    }

    handleChangeFile(attribute, files) {
        files.concat(files.map(file => Object.assign(file, {
            preview: URL.createObjectURL(file)
        })));

        this.onChange(attribute, files);
    }

    handleDeleteFile(attribute, files, key) {
        files.splice(key, 1);

        this.onChange(attribute, files);
    }

    handleChangeNewFile(attribute, old_file_id, comment, files) {
        files.concat(files.map(file => Object.assign(file, {
            preview: URL.createObjectURL(file)
        })));

        let file = [];
        file[old_file_id] = {
            file: files[0],
            old_file_id,
            comment
        };
        const {application} = this.state;

        if (application[attribute]) {
            file = _.merge(application[attribute], file);
        }

        this.onChange(attribute, file);
    }

    fileRow(files, attribute) {
        let values = this.state.documentRelations[attribute];
        let isChecked = Boolean(Number(values ? values.is_checked : 0));

        return map(files, (item, key) => {
            const extension = item.path.match(/\.(\w+)$/)[1];
            const fileLink = `/documents/${item.id}`;

            return [<tr className="tr-file" key={key}>
                <td className="text-left">
                    <div className="d-flex align-items-center">
                        <a
                            className="file-icon-block mr-1"
                            target="_blank"
                            href={fileLink}
                        >
                            <img
                                src={'/images/icons/' + extension + '.svg'}
                                className="file-icon"
                            />

                        </a>
                        <div className="file-title-block">
                            {item.title.replaceAll('_', ' ')} (v{item.version})
                        </div>
                    </div>
                </td>
                <td>
                    <Dropzone
                        disabled={isChecked}
                        onDrop={files => {
                            const comment = prompt('Коментар')
                            this.handleChangeNewFile('new_v_' + attribute, item.id, comment, files)
                        }
                        }>
                        {({getRootProps, getInputProps}) => (
                            <div className="container">
                                <div
                                    {...getRootProps({
                                        className: 'dropzone',
                                        onDrop: event => event.stopPropagation()
                                    })}
                                >
                                    <input {...getInputProps()} />
                                    <button
                                        className="btn btn-sm download-btn btn-outline-warning"
                                        disabled={this.state.disable || isChecked}
                                    >
                                        <i className="fa fa-download" aria-hidden="true"></i>
                                    </button>
                                </div>
                            </div>
                        )}
                    </Dropzone>
                </td>
                <td>{moment(item.updated_at).format('D.M.Y')}</td>
                <td>{moment(item.updated_at).format('HH:mm')}</td>
                <td></td>
                <td></td>
                <td>{item.comment || ''}</td>
            </tr>,
            this.fileNewVersion(this.state.application['new_v_' + attribute], attribute, item.id)];
        });
    }

    fileNewVersion(files, attribute, id) {
        let {errors} = this.state;

        return map(files, (item, key) => {
            if (item) {
                if (item.old_file_id == id) {
                    return <tr className="tr-file" key={key}>
                        <td className="text-left">
                            <div className="d-flex align-items-center">
                                <a
                                    className="file-icon-block mr-1"
                                    target="_blank"
                                    href={item.file.preview ? item.preview : ''}
                                >
                                    <img
                                        src={'/images/icons/' + item.file.name.split('.').pop() + '.svg'}
                                        className="file-icon"
                                    />
                                </a>
                                <div className="file-title-block">
                                    {item.file.name}
                                    {errors[`${attribute}.new_v.${key}.file`] &&
                                    <span className="invalid-feedback d-block">
                                        <strong>
                                            {errors[`${attribute}.new_v.${key}.file`]}
                                        </strong>
                                    </span>
                                    }
                                </div>
                            </div>
                        </td>
                        <td>
                            <button type="button" className="btn btn-sm btn-outline-danger" onClick={() => {
                                this.handleDeleteFile('new_v_' + attribute, files, key)
                            }}>
                                <i className="fa fa-times" aria-hidden="true"></i>
                            </button>
                        </td>
                        <td>{moment().format('D.M.Y')}</td>
                        <td>{moment().format('HH:mm')}</td>
                        <td></td>
                        <td></td>
                        <td>{item.comment ? item.comment : ''}</td>
                    </tr>;
                }
            }
        });
    }

    fileNewRow(files, attribute) {
        let {errors} = this.state;

        return map(files, (item, key) => {
            return <tr className="tr-file" key={key}>
                <td className="text-left">
                    <div className="d-flex align-items-center">
                        <a
                            className="file-icon-block mr-1"
                            target="_blank"
                            href={item.preview ? item.preview : ''}
                        >
                            <img
                                src={'/images/icons/' + item.name.split('.').pop() + '.svg'}
                                className="file-icon"
                            />
                        </a>
                        <div className="file-title-block">
                            {item.name}
                            <div>
                                {errors[`${attribute}.new.${key}`] &&
                                <span className="invalid-feedback d-block">
                                    <strong>
                                        {errors[`${attribute}.new.${key}`]}
                                    </strong>
                                </span>
                                }
                            </div>
                        </div>
                    </div>
                </td>
                <td>
                    <button
                        type="button"
                        className="btn btn-sm btn-outline-danger"
                        onClick={() => {
                            this.handleDeleteFile('new_' + attribute, files, key)
                        }}
                    >
                        <i className="fa fa-times" aria-hidden="true"></i>
                    </button>
                </td>
                <td>{moment().format('D.M.Y')}</td>
                <td>{moment().format('HH:mm')}</td>
                <td></td>
                <td></td>
                <td></td>
            </tr>;
        })
    }

    fileGroupRow(title, attribute, hasFiles) {
        let {application, errors} = this.state;
        let values = this.state.documentRelations[attribute];
        let isNeed = Boolean(Number(values ? values.is_need : 0));
        let isChecked = Boolean(Number(values ? values.is_checked : 0));

        return <tr key={attribute}>
            <td className="text-left doc-tooltip">
                <strong>{title}</strong>
                {errors[attribute] &&
                <span className="invalid-feedback d-block">
                   <strong>
                      {errors[attribute]}
                   </strong>
                </span>
                }
            </td>
            <td>
                <Dropzone
                    disabled={isChecked}
                    onDrop={(acceptedFiles) => {
                        if (application['new_' + attribute]) {
                            this.handleChangeFile('new_' + attribute, application['new_' + attribute].concat(acceptedFiles));
                        } else {
                            this.handleChangeFile('new_' + attribute, acceptedFiles);
                        }
                    }}>
                    {({getRootProps, getInputProps}) => (
                        <div className="container">
                            <div
                                {...getRootProps({
                                    className: 'dropzone',
                                    onDrop: event => event.stopPropagation()
                                })}
                            >
                                <input {...getInputProps()} />
                                <button className="btn btn-sm download-btn btn-outline-primary" disabled={this.state.disable || isChecked}>
                                    <i className="fa fa-download" aria-hidden="true"></i>
                                </button>
                            </div>
                        </div>
                    )}
                </Dropzone>
            </td>
            <td>{values.checked_at && moment(values.checked_at).format('D.M.Y')}</td>
            <td>{values.checked_at && moment(values.checked_at).format('HH:mm')}</td>
            <td>
                {isChecked ? 'Так' : 'Ні'}
            </td>
            <td>
                {isNeed ? 'Так' : 'Ні'}
            </td>
            <td>
                <div className="form-group mb-0">
                <textarea
                    id={`${attribute}_comment`}
                    className="form-control"
                    name={`${attribute}_comment`}
                    rows='3'
                    defaultValue={values ? values.comment : ''}
                    disabled={true}
                    maxLength={100}
                />
                </div>
            </td>
        </tr>;
    }

    hasValues(files) {
        if (typeof files !== 'undefined' && files.length > 0) {
            return true
        } else {
            return false;
        }
    }

    render() {
        const {application} = this.state;

        if(this.state.success) {
            return (
                <div className="row">
                    <div className="col-12">
                        <p className="text-center my-5">
                            <i className="fa text-success fa-5x fa-check" aria-hidden="true"></i>
                            <h3 className="mb-4">Дякуємо! Документи успішно відправлено</h3>
                            <a href="/" className="btn btn-primary">На головну</a>
                        </p>
                    </div>
                </div>
            )
        }

        return (
            <div className="row">
                <div className="col-xl-12 table-responsive">
                    <table className="table text-center mb-0 file-table">
                        <thead>
                        <tr>
                            <th width="45%">
                                Документи
                            </th>
                            <th>
                                Завантажити
                            </th>
                            <th>
                                Дата
                            </th>
                            <th>
                                Час
                            </th>
                            <th width="5%">
                                Перевірено
                            </th>
                            <th width="5%">
                                Надати документи
                            </th>
                            <th>
                                Коментар
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                        {[
                            this.fileGroupRow(
                                'Заява приєднання (скан підписаний від руки)',
                                'join_scan_document',
                                this.hasValues(application.join_scan_document) || this.hasValues(application.new_join_scan_document),
                            ),
                            this.fileRow(application.join_scan_document, 'join_scan_document'),
                            this.fileNewRow(application.new_join_scan_document, 'join_scan_document')
                        ]}

                        {[
                            this.fileGroupRow(
                                'Заява приєднання (ЕЦП)',
                                'join_ecp_document',
                                this.hasValues(application.join_ecp_document) || this.hasValues(application.new_join_ecp_document)
                            ),
                            this.fileRow(application.join_ecp_document, 'join_ecp_document'),
                            this.fileNewRow(application.new_join_ecp_document, 'join_ecp_document')
                        ]}

                        {[
                            this.fileGroupRow(
                                'Паспорт',
                                'passport_document',
                                this.hasValues(application.passport_document) || this.hasValues(application.new_passport_document)
                            ),
                            this.fileRow(application.passport_document, 'passport_document'),
                            this.fileNewRow(application.new_passport_document, 'passport_document')
                        ]}

                        {[
                            this.fileGroupRow(
                                'ІПН',
                                'ipn_document',
                                this.hasValues(application.ipn_document) || this.hasValues(application.new_ipn_document)
                            ),
                            this.fileRow(application.ipn_document, 'ipn_document'),
                            this.fileNewRow(application.new_ipn_document, 'ipn_document')
                        ]}

                        {[
                            this.fileGroupRow(
                                'Документи на право власності',
                                'ownership_document',
                                this.hasValues(application.ownership_document) || this.hasValues(application.new_ownership_document)
                            ),
                            this.fileRow(application.ownership_document, 'ownership_document'),
                            this.fileNewRow(application.new_ownership_document, 'ownership_document'),
                        ]}

                        {[
                            this.fileGroupRow(
                                'Копія заяви-приєднання Оператора ГРМ ',
                                'join_operator_grm_document',
                                this.hasValues(application.join_operator_grm_document) || this.hasValues(application.new_join_operator_grm_document)
                            ),
                            this.fileRow(application.join_operator_grm_document, 'join_operator_grm_document'),
                            this.fileNewRow(application.new_join_operator_grm_document, 'join_operator_grm_document'),
                        ]}
                        </tbody>
                    </table>
                </div>
                <div className="col-12 mt-3">
                    <button className="btn btn-primary pull-right" onClick={this.save}>
                        Відправити
                    </button>
                </div>
            </div>
        )
    }
}
